// import 'bootstrap/dist/css/bootstrap.min.css';

// import 'pushin/dist/pushin.css';

import 'bootstrap/dist/js/bootstrap.bundle';

import "./import/modules";
import "./import/multilanguage";
import "./import/components";
import "./import/animation";

// import "./import/magnet-mouse";


